import { DateInputConstant } from 'config';

export const minEndDate = (date: Date) => {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1);
};

export const getOptions = (arr: Array<number | string>) => {
  return arr.map(
    (mth) => ({ label: String(mth), value: String(mth) } as const),
  );
};

export const isLastMonthDay = (day: number, date: Date) => {
  const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

  return lastDay.getDate() === day;
};

export const boxDate = (date: Date | null): string | null => {
  if (!date) return null;

  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();

  return [year, month, day].join('-');
};

export const unboxDate = (str: string | null | undefined): Date | undefined =>
  str ? new Date(str) : undefined;

const yearsList = () => {
  const min = Number(DateInputConstant.MIN_AVAILABLE_YEAR);
  const max = Number(DateInputConstant.MAX_AVAILABLE_YEAR);

  const innerYear: number[] = [];

  for (let i = min; i <= max; i += 1) {
    innerYear.push(i);
  }

  return innerYear;
};

export const yearOptions = getOptions(yearsList());
